import React from "react";
import { Link } from "react-router-dom";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import { WhatsAppButton } from "@/components/site/WhatsButton";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const { faqs, settings } = useData();
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question", name: f.domanda,
      acceptedAnswer: { "@type": "Answer", text: f.risposta },
    })),
  };

  return (
    <>
      <Seo title="Domande frequenti" description="Risposte alle domande più frequenti su sopralluoghi gratuiti, preventivi, potature, abbattimenti e realizzazione di giardini." path="/domande-frequenti" schema={schema} />
      <PageHero
        overline="FAQ"
        title="Domande frequenti"
        subtitle="Le risposte alle domande più comuni. Per qualsiasi altra informazione siamo a tua disposizione."
        breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Domande frequenti</span></>}
      />

      <section className="bg-av-black py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={f.id} value={f.id} className="border-white/10">
                  <AccordionTrigger data-testid={`faq-item-${i}`} className="text-left font-display text-lg sm:text-xl text-av-white hover:text-av-lime hover:no-underline py-6">
                    {f.domanda}
                  </AccordionTrigger>
                  <AccordionContent className="text-av-gray text-base leading-relaxed pb-6">
                    {f.risposta}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <div className="mt-14 text-center">
            <h2 className="font-display text-2xl text-av-white">Hai altre domande?</h2>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <WhatsAppButton />
              {settings && <a href={`tel:${settings.telefono_link}`} className="inline-flex items-center gap-2 rounded-full border border-white/25 text-av-white px-6 py-3 text-sm font-semibold hover:border-av-lime hover:text-av-lime transition-colors">Chiama il {settings.telefono}</a>}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
